<div
  gtm="onToggle"
  gtmAction="Single room control supply channel toggle"
  gtmCategory="singleRoomControl"
>
  <div class="flex flex-row items-center w-full justify-between">
    <p>
      {{
        '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.VICARE_OPTIMIZATION.SUPPLY_CHANNEL'
          | translate
      }}
      {{ ' ' + (+roomChannelsEntity.properties.id.value + 1) }}
    </p>

    <mat-slide-toggle
      [checked]="roomChannelsEntity.properties?.roomInfluenceEnabled.value"
      (change)="onChannelOptimizationToggle($event.checked)"
    ></mat-slide-toggle>
  </div>
</div>
